import React from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {Button, Card, Col, Form, Icon, Input, Modal, Row, Select, Slider, Table, Tooltip} from "antd";
import {GUTTER_MD, SPAN_TWO_QUARTERS} from "../../../../../styles/constants";

const columns = (cardIndex, inputErrors, handleInputChange) => [
    {
        title: 'SDMX Period',
        dataIndex: 'sdmxPeriod',
        key: 'sdmxPeriod',
        className: 'zero-padding-td',
        sorter: false,
        sortOrder: false,
        filterDropdownVisible: false,
        filterMultiple: false,
    },
    {
        title: 'Local Period',
        dataIndex: 'localPeriod',
        key: 'localPeriod',
        className: 'zero-padding-td',
        sorter: false,
        sortOrder: false,
        filterDropdownVisible: false,
        filterMultiple: false,
        render: (text, record) => {
            return {
                children:
                    (
                        <Form.Item
                            name={`localPeriod_${record.key}`}
                            key={`localPeriod_${record.key}`}
                            validateStatus={inputErrors[`localPeriod_${record.key}`] === 'error' ? 'error' : undefined}
                        >
                            <Input
                                style={{backgroundColor: inputErrors[`localPeriod_${record.key}`] === 'error' ? 'red' : ''}}
                                onChange={(e) => handleInputChange(cardIndex, record.key, e.target.value)}
                                value={text}
                            />
                        </Form.Item>
                    )
            }
        }
    },
];

const FrequencyCard = ({
                           t,
                           card,
                           index,
                           frequencyCards,
                           setFrequencyCards,
                           data,
                           handleFrequency,
                           handleChangeSlider,
                           handleSelect,
                           handleInputChange,
                           inputErrors
                       }) => {
    return (
        <Card key={index} style={{marginBottom: 40}}>
            <Row type="flex" gutter={GUTTER_MD}>
                <Col span={SPAN_TWO_QUARTERS}>
                    <Row type="flex" style={{marginBottom: 20}}>
                        <Col span={SPAN_TWO_QUARTERS}>
                            <p>{t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.labels.frequency')}</p>

                            <Select
                                style={{width: '100%'}}
                                title={t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.labels.frequency')}
                                onChange={(value) => handleFrequency(index, value)}
                                value={card.frequency}
                            >
                                <Select.Option key={'A-YEARLY'}
                                               disabled={frequencyCards.some(item => item.frequency === 'A')}
                                               value="A">{t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.labels.yearly')}</Select.Option>
                                <Select.Option key={'S-HALF'}
                                               disabled={frequencyCards.some(item => item.frequency === 'S')}
                                               value="S">{t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.labels.halfYearly')}</Select.Option>
                                <Select.Option key={'Q-QUARTERLY'}
                                               disabled={frequencyCards.some(item => item.frequency === 'Q')}
                                               value="Q">{t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.labels.quarterly')}</Select.Option>
                                <Select.Option key={'M-MONTHLY'}
                                               disabled={frequencyCards.some(item => item.frequency === 'M')}
                                               value="M">{t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.labels.monthly')}</Select.Option>
                            </Select>
                        </Col>
                    </Row>
                    <Row type="flex" gutter={GUTTER_MD}>
                        <Col span={SPAN_TWO_QUARTERS}>
                            {data && data.columnObject && card.frequency && (
                                <Row>
                                    <div>
                                        <span>
                                            <p>{t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.labels.yearColumn')}</p>

                                            <Select
                                                style={{width: '100%'}}
                                                onChange={(selectedOption) => handleSelect(index, selectedOption, true)}
                                                value={card.optionYearColumn}
                                                showSearch
                                                filterOption={(inputValue, {props}) =>
                                                    props.value.toLowerCase().includes(inputValue.toLowerCase())
                                                }
                                            >
                                                {(
                                                    data.columnObject.map((columnIndexYear) =>
                                                        <Select.Option
                                                            key={`year_${columnIndexYear.entityId}_${index}`}
                                                            value={columnIndexYear.name}
                                                            title={`year_${columnIndexYear}_${index}`}>
                                                            {columnIndexYear.name}
                                                        </Select.Option>)
                                                )}
                                            </Select>
                                        </span>
                                    </div>
                                </Row>
                            )}
                            <Row style={{marginTop: 10}}>
                                {card.frequency && (
                                    <div>
                                        <p>{t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.labels.highlightYear')}</p>
                                        <Slider handleColor='#91caff' handleActiveColor='#1677ff'
                                                onChange={(value) => handleChangeSlider(index, value, true)}
                                                marks={card.yearMarks.marks}
                                                step={card.yearMarks.step}
                                                range={card.yearMarks.max > 0}
                                                draggableTrack={card.yearMarks.max}
                                                value={card.yearSlider ? card.yearSlider : [0, 0]}
                                                included={true}
                                                min={0}
                                                max={card.yearMarks.max}
                                        />
                                    </div>
                                )}
                            </Row>
                            {card.frequency && card.frequency !== 'A' ? (
                                <Row>
                                    <div>
                                        <span>
                                            <p>{t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.labels.periodColumn')}</p>
                                            {data && data.columnObject && (
                                                <Select
                                                    style={{width: '100%'}}
                                                    onChange={(selectedOption) => handleSelect(index, selectedOption, false)}
                                                    value={card.optionPeriodColumn}
                                                    showSearch
                                                    filterOption={(inputValue, {props}) =>
                                                        props.value.toLowerCase().includes(inputValue.toLowerCase())
                                                    }
                                                >
                                                    {(
                                                        data.columnObject.map((columnIndex) =>
                                                            <Select.Option
                                                                key={`period_${columnIndex.entityId}_${index}`}

                                                                value={columnIndex.name}
                                                                title={`period_${columnIndex.name}_${index}`}>
                                                                {columnIndex.name}
                                                            </Select.Option>)
                                                    )}
                                                </Select>
                                            )}
                                        </span>
                                    </div>
                                </Row>
                            ) : null}
                            <Row style={{marginTop: 10}}>
                                {card.frequency && (card.frequency && card.frequency !== 'A') ? (
                                    <div>
                                        <p>{t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.labels.highlightPeriod')}</p>
                                        <Slider handleColor='#91caff' handleActiveColor='#1677ff'
                                                onChange={(value) => handleChangeSlider(index, value, false)}
                                                marks={card.periodMarks.marks}
                                                step={card.periodMarks.step}
                                                range={card.periodMarks.max > 0}
                                                draggableTrack={card.periodMarks.max}
                                                value={card.periodSlider ? card.periodSlider : [0, 0]}
                                                included={true}
                                                min={0}
                                                max={card.periodMarks.max}
                                        />
                                    </div>

                                ) : null}
                            </Row>
                        </Col>
                    </Row>
                </Col>
                {(card.dataTable && (card.frequency && card.frequency !== 'A') && (
                    <Col span={SPAN_TWO_QUARTERS}>
                        <Form>
                            <Table
                                style={{paddingTop: 0, paddingBottom: 0}}
                                bordered
                                size="small"
                                rowKey={(row) => row.key}
                                expandRowByClick={false}
                                dataSource={card.dataTable}
                                columns={columns(index, inputErrors, handleInputChange)}
                                pagination={false}
                                component={false}
                            />
                        </Form>
                    </Col>
                ))}
            </Row>
            {frequencyCards && frequencyCards.length > 1 && (
                <Row>
                    <Tooltip
                        title={t("scenes.mappingHandler.MappingSet.transcoding.tooltip.removeFrequency")}>
                        <Button
                            onClick={() =>
                                Modal.confirm({
                                    title: t('commons.artefact.modals.transcoding.delete.frequency.title'),
                                    onOk() {
                                        setFrequencyCards(prevState => ([...prevState]).filter((_, itemIndex) => itemIndex !== index))
                                    },
                                    cancelText: t('commons.buttons.cancel.title')
                                })
                            }
                        >
                            <Icon type="delete"/>
                            {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.buttons.timeTranscoding.deleteFrequency")}
                        </Button>
                    </Tooltip>
                </Row>)}

        </Card>
    )
}

export default compose(
    translate(),
)(FrequencyCard);